<app-jwplayer
#video
class="w-100-p"
*ngIf="videoPlayerType == 'jwPlayer'"
[sensor]="sensor"
[analysedVid]="analysedVid"
></app-jwplayer>
<app-iframe-video-player
class="w-100-p"
*ngIf="videoPlayerType == 'iframe'"
[sensor]="sensor"
></app-iframe-video-player>
<app-wowza-webrtc-player 
class="w-100-p" 
*ngIf="(videoPlayerType == 'webrtc') && isWebRtcResourcesReady" 
[signalingUrl]="signalingUrl"
[applicationName]="applicationName" 
[streamName]="sensor.streamName" 
[secureToken]="tokenObject"   
[muted]="videoMuted">
</app-wowza-webrtc-player>
<app-flow-player 
class="w-100-p" 
*ngIf="(videoPlayerType == 'flow') && isWebRtcResourcesReady" 
[sdpUrl]="signalingUrl"
[applicationName]="applicationName" 
[streamName]="sensor.streamName" 
[secureToken]="tokenObject"   
[enableDebugLogging]="enableDebugLogging">
</app-flow-player>